import { InformationCard } from '@europrocurement/flexy-components';
import { type DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup } from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { Box, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { faWarning } from '@fortawesome/pro-duotone-svg-icons';
import { DOC_TYPE_REQUIRED, PrescripteurApi } from '@europrocurement/l2d-domain';
import { useDossierDocumentsCtx } from '@europrocurement/l2d-modules/providers';
import { type DisplayedDocument } from '@europrocurement/l2d-modules/modules/Dossiers/providers/types';
import { DocToSend } from './DocToSend';

type RecapDocumentsProps = {
    prescripteur: PrescripteurApi;
    innerDossier: DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup;
};
const RecapDocuments: React.FunctionComponent<RecapDocumentsProps> = function ({
    prescripteur,
    innerDossier,
}) {
    const theme = useTheme();
    const { dosDocs, getDossierDocumentsByCategory } = useDossierDocumentsCtx();
    const [documents, setDocuments] = useState<DisplayedDocument[]>([]);

    useEffect(() => {
        setDocuments(
            [
                ...getDossierDocumentsByCategory({ categoryId: DOC_TYPE_REQUIRED }),
                ...getDossierDocumentsByCategory({
                    categoryId: DOC_TYPE_REQUIRED,
                    additionalDocs: true,
                }),
            ].map((item) => ({
                ...item,
                movable: false,
            })),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dosDocs]);

    return (
        <InformationCard
            title="Documents"
            sx={{
                backgroundColor: theme.palette.background.dark,
                boxShadow: '0px 2px 2.5px 0px rgba(193, 202, 215, 0.25)',
            }}
            items={documents.map((doc) => ({
                key: doc.id,
                label: doc.label,
                value: (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '5px',
                            alignItems: 'start',
                        }}
                    >
                        <Typography
                            color={doc.fichierId ? theme.palette.primary.dark : 'text.gris50'}
                            sx={{ fontSize: '15px' }}
                        >
                            {doc.fichierId ? doc.fileName : 'Manquant'}
                        </Typography>
                        <Typography
                            color="text.gris50"
                            sx={{ fontSize: '10px' }}
                        >
                            <FaOptionIcon
                                icon={doc.fichierId ? faCircleCheck : faWarning}
                                color={doc.fichierId ? 'text.gris70' : theme.palette.warning.dark}
                            />
                        </Typography>
                    </Box>
                ),
            }))}
            labelCount={{
                plurialLabel: 'documents transmis',
                singularLabel: 'document transmis',
            }}
            listComponent={
                <Box sx={{ padding: '0 32px' }}>
                    <DocToSend
                        dossier={innerDossier}
                        prescripteur={prescripteur}
                    />
                </Box>
            }
        />
    );
};

export default RecapDocuments;
